import styled from 'styled-components';

export const PresetGrid = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Textarea = styled.textarea`
	box-sizing: border-box;
	width: 100%;
	min-height: 90px;
	padding: 10px 12px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	background: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;
	font-family: inherit;
	line-height: 1.4;
	resize: vertical;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;
